<template>
    <div v-if="getCompanyDetail.data">
        <nav>
            <ol class="breadcrumb p-1 mb-1">
                <span class="ml-auto mr-2 text-muted"> {{getCompanyDetail.data.member_info.length}} 件</span>
            </ol>
        </nav>
        <div class="card mb-2" v-if="getCompanyDetail.data.member_info.length != 0">
            <ul class="list-group list-group-flush border-bottom-0">
                <li class="list-group-item px-2 pb-0" v-for="item in getCompanyDetail.data.member_info" :key="item.id">
                    <div class="wrapper-name">
                        <div class="mr-2 name">
                            <span v-if="item.is_handle">
                                <i class="fas fa-user-tie text-danger-cust"></i>&nbsp;(オーナー)
                            </span>
                            <span v-else>
                                <i v-if="item.is_owner" class="fas fa-user text-success"></i>
                                <i v-else class="fas fa-user"></i>
                                &nbsp;{{item.name}}
                                <span v-if="item.is_link == '1'" class="text-danger">
                                    <small>(解除済)</small>
                                </span>
                            </span>
                        </div>
                        <div v-if="item.is_handle" class="ml-2 flex-fill text-right">
                            <i class="fas fa-hand-holding-medical" :class="{'text-success': item.can_invite == '0'}"></i>
                            &nbsp;{{item.invited_cnt}}/{{item.can_invite_cnt}}&nbsp;
                            <span class="ml-4" @click="openSet(item.can_invite,item.can_invite_cnt,item.id,item.user_group)">
                                <i class="fas fa-cog icon-size"></i>
                            </span>
                        </div>
                    </div>
                    <div class="text-nowrap flex-fill text-right text-muted">
                        <small>
                            {{item.created_at | dformatf}}
                        </small>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 0件メッセージ -->
        <not-found-msg v-else></not-found-msg>
    </div>
</template>

<script>
    import NotFoundMsg from 'pages/commons/notFoundMsg/NotFoundMsg'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            NotFoundMsg
        },
        computed: {
            ...mapGetters(['getCompanyDetail'])
        },
        methods: {
            openSet (can,cnt,id,group) {
                this.$parent.openSet(can, cnt, id, group)
            }
        }

    }
</script>
 
<style lang="stylus" scoped>
    @import '~stylus/base/mixins.styl'
    .wrapper-name
        display:flex
        white-space: nowrap
        .name
            ellipsis()
</style>
